import i18n from "@/i18n";
import router from "@/router";

export default function changeLocale(locale) {
  i18n.locale = locale;
  localStorage.setItem("locale", locale);
  router.go();
}
